import { motion } from "framer-motion";
import CountUp from "react-countup";
import { Calculator, ArrowRight } from "lucide-react";
import { getMotivationalMessage } from "./config";
import { Button } from "../ui/button";

const ResultsDashboard = ({ totals, totalBusinesses }) => {
  const message = getMotivationalMessage(totals.year1);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-gradient-to-br from-[#0B1120] to-[#0F172A] rounded-3xl p-8 text-white"
    >
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#0099CC]/20 rounded-full mb-4">
          <Calculator className="w-4 h-4 text-[#0099CC]" />
          <span className="text-sm font-medium text-[#0099CC]">Your Network Value</span>
        </div>
        <h3 className="text-2xl md:text-3xl font-bold mb-2">Potential Income Summary</h3>
        <p className="text-slate-400">Based on {totalBusinesses} business{totalBusinesses !== 1 ? 'es' : ''} in your network</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <div className="bg-white/5 rounded-2xl p-4 text-center border border-white/10">
          <p className="text-xs text-slate-400 uppercase tracking-wide mb-2">Monthly</p>
          <p className="text-2xl md:text-3xl font-bold text-white font-numbers">
            {totals.monthly > 0 ? (
              <CountUp
                end={totals.monthly}
                duration={1.5}
                separator=","
                prefix="$"
              />
            ) : '$0'}
          </p>
        </div>
        <div className="bg-white/5 rounded-2xl p-4 text-center border border-white/10">
          <p className="text-xs text-slate-400 uppercase tracking-wide mb-2">Year 1</p>
          <p className="text-2xl md:text-3xl font-bold text-white font-numbers">
            {totals.year1 > 0 ? (
              <CountUp
                end={totals.year1}
                duration={1.5}
                separator=","
                prefix="$"
              />
            ) : '$0'}
          </p>
        </div>
        <div className="bg-white/5 rounded-2xl p-4 text-center border border-[#0099CC]/30">
          <p className="text-xs text-[#0099CC] uppercase tracking-wide mb-2">5 Years</p>
          <p className="text-2xl md:text-3xl font-bold text-[#0099CC] font-numbers">
            {totals.year5 > 0 ? (
              <CountUp
                end={totals.year5}
                duration={1.5}
                separator=","
                prefix="$"
              />
            ) : '$0'}
          </p>
        </div>
        <div className="bg-gradient-to-br from-[#0099CC]/20 to-[#0099CC]/10 rounded-2xl p-4 text-center border border-[#0099CC]/30">
          <p className="text-xs text-[#0099CC] uppercase tracking-wide mb-2">10 Years</p>
          <p className="text-2xl md:text-3xl font-bold text-[#0099CC] font-numbers">
            {totals.year10 > 0 ? (
              <CountUp
                end={totals.year10}
                duration={1.5}
                separator=","
                prefix="$"
              />
            ) : '$0'}
          </p>
        </div>
      </div>

      {message && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="text-center mb-8"
        >
          <p className="text-lg text-slate-300 italic">"{message}"</p>
        </motion.div>
      )}

      {/* Join Today CTA */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
        className="text-center mt-8 pt-8 border-t border-white/10"
      >
        <h4 className="text-2xl md:text-3xl font-bold text-white mb-2">
          Join Today Risk FREE for 30 days
        </h4>
        <p className="text-slate-400 mb-6">
          Start turning your network into recurring income
        </p>
        <a href="https://checkout.partnerwithaspirepartners.com/" target="_blank" rel="noopener noreferrer">
          <Button className="bg-[#0099CC] hover:bg-[#007EA8] text-white rounded-full px-10 py-6 text-lg font-semibold shadow-lg shadow-blue-500/30 transition-all hover:scale-105">
            Join Today
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </a>
        <p className="mt-4 text-[#0099CC] font-semibold">
          100% Risk FREE · Try it FREE for 30 days · Then just $97/month
        </p>
      </motion.div>
    </motion.div>
  );
};

export default ResultsDashboard;
